import { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { topics } from "@/mocks/topics";
import { formatHeat } from "@/utils/format";
import SectionHeading from "@/components/feature/SectionHeading";

const yearTabs = ["2025 年度", "2024 年度"];

export default function RankingBoard() {
  const [activeYear, setActiveYear] = useState(2025);

  const ranked = useMemo(
    () =>
      topics
        .filter((t) => t.year === activeYear)
        .sort((a, b) => b.heat - a.heat)
        .slice(0, 6),
    [activeYear]
  );

  return (
    <section className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-100">
      <SectionHeading
        eyebrow="Top Ranking"
        title="话题热度 TOP 榜"
        desc="综合讨论量、回放量与二创数量加权排序，看谁真正撑起了这一年的讨论量。"
        actionPath="/rankings"
        actionLabel="查看完整榜单"
      />

      <div className="mt-8 flex items-center gap-1 px-1 py-1 rounded-full bg-background-200/70 w-fit">
        {yearTabs.map((tab, index) => {
          const year = index === 0 ? 2025 : 2024;
          return (
            <button
              key={tab}
              type="button"
              onClick={() => setActiveYear(year)}
              className={`px-5 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                activeYear === year
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:text-primary-600"
              }`}
            >
              {tab}
            </button>
          );
        })}
      </div>

      <div className="mt-8 grid grid-cols-1 lg:grid-cols-3 gap-6">
        {ranked.slice(0, 3).map((topic, index) => (
          <Link
            key={topic.slug}
            to={`/topic/${topic.slug}`}
            className="group relative rounded-lg bg-background-50 border border-background-200 p-5 md:p-6 flex flex-col hover:border-primary-300 transition-colors"
          >
            <span
              className={`w-11 h-11 rounded-full flex items-center justify-center font-heading font-black text-lg ${
                index === 0
                  ? "bg-accent-500 text-foreground-950"
                  : "bg-secondary-100 text-secondary-800"
              }`}
            >
              {topic.rank}
            </span>
            <h3 className="mt-4 font-heading font-bold text-lg leading-snug text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2">
              {topic.title}
            </h3>
            <p className="mt-2.5 text-sm text-foreground-600 line-clamp-2 flex-1">{topic.summary}</p>
            <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between text-xs text-foreground-500">
              <span>{topic.category}</span>
              <span className="text-primary-600 font-medium">
                <i className="ri-fire-line mr-1" />
                热度 {formatHeat(topic.heat)}
              </span>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-6 rounded-lg bg-background-50 border border-background-200 px-5 py-2">
        {ranked.slice(3).map((topic) => (
          <Link
            key={topic.slug}
            to={`/topic/${topic.slug}`}
            className="group flex items-center gap-4 py-3.5 border-b border-background-200 last:border-0"
          >
            <span className="w-6 text-center font-heading font-bold text-foreground-500">
              {topic.rank}
            </span>
            <span className="flex-1 min-w-0 text-sm text-foreground-900 group-hover:text-primary-600 transition-colors truncate">
              {topic.title}
            </span>
            <span className="hidden sm:inline text-xs text-foreground-500 whitespace-nowrap">
              {topic.category}
            </span>
            <span className="text-xs text-primary-600 font-medium whitespace-nowrap">
              {formatHeat(topic.heat)}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}